export const toggleText = (currentLang, languages) =>{
    if(currentLang && languages){
       return languages[currentLang]; 
    }
    
}